import { css } from 'aphrodite';
import * as React from 'react';
import { IActionButton } from './ActionBarButtonTypes';
import { styleSheet } from './styles';

export const ActionBarButton: React.FC<IActionButton> = ({
	icon,
	children,
	onClick,
	disabled,
	styleClass,
	isFullWidth,
}) => {
	// Consider it icon-only if there's no label OR if we're at a small screen width
	// where the text will be hidden by CSS
	const isIconOnly = !children;

	return (
		<button
			className={css(
				styleSheet.actionButton,
				isIconOnly && styleSheet.actionButtonIconOnly,
				disabled ? styleSheet.actionButtonDisabled : styleSheet.actionButtonEnabled,
				styleClass,
				isFullWidth && styleSheet.fullWidth
			)}
			onClick={onClick}
			disabled={disabled}
		>
			{icon}
			{children && <span className={css(styleSheet.actionButtonText)}>{children}</span>}
		</button>
	);
};
